import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export interface IStarIconProps {
    className?: string;
}

const StarIcon = (props: IStarIconProps) => {
    const className = classNames('elc-star-icon', props.className);
    const image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' preserveAspectRatio='none'%0Astroke='%23000000' strokeWidth='1px' %3E%3Cpath d='M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z' /%3E%3C/svg%3E")`;

    return <Icon className={className} size={'medium'} image={image} />;
};

export { StarIcon };
